<template>
    <layout>
        <user/> 

        <v-container fluid>
            <v-row class="mt-4">
                <v-col
                    align="center"
                    justify="center"
                >
                    <v-card            
                        width="700"
                        flat
                    >  
                        
                        <v-img
                            :src="require('../assets/logo.png')"
                            contain
                            height="70"
                        />
                        <h1 class="primary--text  font-weight-bold">
                            Arima North Secondary School
                        </h1>
                        <div class="text-h6 font-weight-light primary--text">
                            Arima Old Road, Arima
                        </div>
                        <div class="mt-4 primary--text font-weight-bold text-h5">
                            2026 CSEC SUBJECT SELECTION
                        </div>
                        
                    </v-card>
                </v-col>
            </v-row>
            
            <v-row class="">
                <v-col
                    align="center"
                    justify="center"
                >
                    <v-card            
                        width="550"
                        class="mt-10"
                    >  
                        <v-card-title class="secondary--text pl-4 primary">
                            STUDENT INFORMATION
                        </v-card-title>
                        
                    </v-card>
                </v-col>
            </v-row>

            <v-row
                align="center"
                justify="center"
            >
                <v-card
                    class="pa-6 mt-5" 
                    width="550"
                >
                    <v-row 
                        align="center"
                        justify="center"
                        v-for="(field, index) in fields"
                        :key="index"
                    >
                        <v-col
                            cols="12"                       
                        >
                            <date-picker
                                v-if="field.type == 'date'"
                                v-bind:label="field.label"
                                v-bind:date="recordApplication[field.model]"
                                v-on:change-date="updateDate"
                                v-bind:saveStatus="field.saveStatus"
                            ></date-picker>


                            <!-- Phone field -->
                            <v-text-field
                                v-else-if="field.type == 'phone'"
                                v-bind:label="field.label"
                                v-model="recordApplication[field.model]"
                                @keypress="numberOnly"
                                :prepend-icon="field.icon"
                                placeholder=" "
                                hint="Enter 7 digits only"
                                persistent-hint
                                prefix="1868"
                                maxlength="7"
                                autocomplete="none"
                                :ref='field.ref'
                                :rules="[() => recordApplication[field.model] && recordApplication[field.model].length == 7 || '7 Digits Needed']" 
                                @change="updateApplication"                                                 
                            >
                                 <template v-slot:append>
                                    <v-fade-transition>
                                        <v-progress-circular
                                            v-if="field.saveStatus.saving"
                                            size="16"
                                            width="3"
                                            color="info"
                                            indeterminate
                                        ></v-progress-circular>
                                    </v-fade-transition>

                                    <v-fade-transition>    
                                        <v-icon
                                            v-if="field.saveStatus.saveSuccess"
                                            small
                                            color="info"                                        
                                        >
                                            mdi-check-all
                                        </v-icon>
                                    </v-fade-transition>

                                    <v-fade-transition>    
                                        <v-icon
                                            v-if="field.saveStatus.saveError"
                                            small
                                            color="red"                                        
                                        >
                                            mdi-alert-circle
                                        </v-icon>
                                    </v-fade-transition>
                                </template>
                            </v-text-field>

                            <v-select
                                v-else-if="field.type == 'select'"
                                v-bind:label="field.label"
                                v-model="recordApplication[field.model]"
                                :prepend-icon="field.icon"                            
                                autocomplete="none"
                                :counter="field.counter"
                                :maxlength="field.maxlength" 
                                :disabled="field.disabled"
                                :filled="field.filled"
                                :items="field.items"
                                :ref="field.ref"
                                hide-details  
                                @change="updateApplication"      
                            >
                                <template v-slot:append>
                                    <v-fade-transition>
                                        <v-progress-circular
                                            v-if="field.saveStatus.saving"
                                            size="16"
                                            width="3"
                                            color="info"
                                            indeterminate
                                        ></v-progress-circular>
                                    </v-fade-transition>

                                    <v-fade-transition>    
                                        <v-icon
                                            v-if="field.saveStatus.saveSuccess"
                                            small
                                            color="info"                                        
                                        >
                                            mdi-check-all
                                        </v-icon>
                                    </v-fade-transition>

                                    <v-fade-transition>    
                                        <v-icon
                                            v-if="field.saveStatus.saveError"
                                            small
                                            color="red"                                        
                                        >
                                            mdi-alert-circle
                                        </v-icon>
                                    </v-fade-transition>
                                </template>
                            </v-select>

                            <v-text-field
                                v-else
                                v-bind:label="field.label"
                                v-model="recordApplication[field.model]"
                                :prepend-icon="field.icon"                            
                                autocomplete="none"
                                :counter="field.counter"
                                :maxlength="field.maxlength" 
                                :disabled="field.disabled"
                                :filled="field.filled"
                                :ref="field.ref"
                                hide-details   
                                @change="updateApplication"
                            >
                                <template v-slot:append>
                                    <v-fade-transition>
                                        <v-progress-circular
                                            v-if="field.saveStatus.saving"
                                            size="16"
                                            width="3"
                                            color="info"
                                            indeterminate
                                        ></v-progress-circular>
                                    </v-fade-transition>

                                    <v-fade-transition>    
                                        <v-icon
                                            v-if="field.saveStatus.saveSuccess"
                                            small
                                            color="info"                                        
                                        >
                                            mdi-check-all
                                        </v-icon>
                                    </v-fade-transition>

                                    <v-fade-transition>    
                                        <v-icon
                                            v-if="field.saveStatus.saveError"
                                            small
                                            color="red"                                        
                                        >
                                            mdi-alert-circle
                                        </v-icon>
                                    </v-fade-transition>
                                </template>
                            </v-text-field>
                        </v-col>
                    </v-row>     
                </v-card>
            </v-row>

            <v-row class="mt-4">
                <v-col
                    align="center"
                    justify="center"
                >
                    <v-card            
                        width="550"
                    >  
                        <v-card-title class="secondary--text pl-4 primary">
                            <div>CHOICE OF CSEC SUBJECTS</div> 
                            
                        </v-card-title>

                        <v-card-text>
                            <div v-for="choice in choices" :key="choice.id" class="mb-10">
                                <v-alert
                                    text
                                    color="primary"
                                    dense
                                    border="left"
                                    colored-border
                                    class="mt-4"
                                >
                                    {{ choice.name }}
                                    <div class="text-caption red--text">Please select form class first</div>
                                </v-alert>
    
                                <v-select
                                    v-model="choice.formClass"
                                    outlined
                                    hide-details=""
                                    label="Form Class"
                                    placeholder=" "
                                    :items="formClasses"
                                    class="mb-4"
                                    dense
                                    @change="updateClassSubjectChoice(choice.id)"
                                ></v-select>
                                
                                <v-data-table
                                    :headers="headersSubjectChoice"
                                    :items="choice.subjectLines"
                                    hide-default-footer
                                    hide-default-header
                                >
                                    <template v-slot:item="{ item }">
                                        <tr>
                                            <td>
                                                {{ item.line }}
                                            </td>
                                            <td>
                                                <v-select
                                                    v-model="subjectsChosen[choice.id][item.line]"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    placeholder="Subject"
                                                    :items="item.subjects"
                                                    item-text="title"
                                                    item-value="subject_id"
                                                    :disabled="item.disabled"
                                                    :filled="item.disabled" 
                                                    @change="updateLineSubjectChoice(choice.id, item.line)"
                                                >
                                                    <template v-slot:append-outer>
                                                        <v-fade-transition>
                                                            <v-progress-circular
                                                                v-if="item.saveStatus.saving"
                                                                size="16"
                                                                width="3"
                                                                color="info"
                                                                indeterminate
                                                            ></v-progress-circular>
                                                        </v-fade-transition>
    
                                                        <v-fade-transition>    
                                                            <v-icon
                                                                v-if="item.saveStatus.saveSuccess"
                                                                small
                                                                color="info"                                        
                                                            >
                                                                mdi-check-all
                                                            </v-icon>
                                                        </v-fade-transition>
    
                                                        <v-fade-transition>    
                                                            <v-icon
                                                                v-if="item.saveStatus.saveError"
                                                                small
                                                                color="red"                                        
                                                            >
                                                                mdi-alert-circle
                                                            </v-icon>
                                                        </v-fade-transition>
                                                    </template>
                                                </v-select>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </div>

                        </v-card-text>
                        
                    </v-card>
                </v-col>
            </v-row>

            <v-row class="mt-4">
                <v-col
                    align="center"
                    justify="center"
                >
                    <v-card            
                        width="550"
                    >  
                        <v-card-text>
                           
                            <div>
                                <v-checkbox
                                    v-model="accept"
                                    label="I accept the terms and conditions"
                                    @change="updateApplication"
                                ></v-checkbox>
                            </div>

                        </v-card-text>
                        
                    </v-card>
                </v-col>
            </v-row>

            <!-- <v-row class="mt-4">
                 <v-col
                    align="center"
                    justify="center"
                >
                    <v-card            
                        width="550"
                    >  
                        <v-btn
                            block
                            color="primary"
                            @click="submitApplicationForm"
                        >
                            Submit Application Form
                        </v-btn>
                    </v-card>
                </v-col>
            </v-row> -->

            <v-row class="mt-4">
                 <v-col
                    align="center"
                    justify="center"
                >
                    <v-card            
                        width="550"
                    >  
                        <v-btn
                            block
                            color="primary"
                            @click="downloadApplicationForm"
                        >
                            Preview Application Form
                        </v-btn>
                    </v-card>
                </v-col>
            </v-row>
            
            <v-overlay :value="overlay">
                <v-progress-circular
                    indeterminate
                    size="64"
                ></v-progress-circular>
            </v-overlay>

        </v-container>

        <v-dialog
            v-model="dialogReport"                      
            persistent
        >
           <v-card height="80vh" v-if="dialogReport">
            <iframe ref="pdf" style="width:100%; height:100%" frameBorder="0" :src="src"></iframe>
           </v-card>

            <v-container
                fluid
                class="pa-0"
            >
                <v-sheet>
                    <v-row
                        justify="end"
                        class="ma-0"
                    >

                        <v-btn
                            color="primary"
                            dark
                            class="my-2 mr-4"
                            @click="closeReport"
                        >
                            Close
                        </v-btn>

                    </v-row>
                </v-sheet>
            </v-container>

        </v-dialog>
    </layout>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Layout from './layouts/App';
import User from './User';
export default {
    name: 'TermReport',
    components: {
        Layout,
        User,            
    },       
    computed: {
        ...mapGetters({            
            getUser: 'auth/getUser',
            admin: 'auth/getAdmin'            
        }),

        user () {
            return JSON.parse(this.getUser);
        },

        regex(){
            return new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) 
        },

        toUpperCase (props) {
            console.log(props);
            return null;
        },

        firstName () {
            return this.user.name.split(" ")[0];
        },

        lastName () {
            return this.user.name.split(" ")[1];
        },
       
       
    },
    mounted(){       
        this.initialize();
        
    },   
     
    data: () => ({
       applicationYear: 2026,
       fields: [
               
            {
                label: 'First Name', 
                model: 'first_name', 
                type: 'text', 
                disabled: false,
                filled: false,
                required: false,
                ref: 'firstName',
                saveStatus: {
                    saving: false,
                    saveSuccess: false,
                    saveError: false,
                }, 
                record: 'application',
            },
                {
                    label: 'Last Name', 
                    model: 'last_name', 
                    type: 'text', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'lastName',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },                    
                    record: 'application',
                },
               
                {
                    label: "Parent's First Name", 
                    model: 'parent_first_name', 
                    type: 'text', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'parentFirstName',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: "Parent's Last Name", 
                    model: 'parent_last_name', 
                    type: 'text', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'parentLastName',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: 'Parent Contact Mobile', 
                    model: 'parent_contact_mobile', 
                    type: 'phone', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'phoneMobileParent',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                
                {
                    label: 'Parent Contact Work', 
                    model: 'parent_contact_work', 
                    type: 'phone', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'phoneWorkParent',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: 'Parent Contact Home', 
                    model: 'parent_contact_home', 
                    type: 'phone', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'phoneHomeParent',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: 'Career Goal', 
                    model: 'career_goal', 
                    type: 'email', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'careerGoal',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
            ],
            recordApplication: {},
            subjects: [
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                
               
            ],
            headersSubjectChoice: [
                {text: ''},               
                {text: ''},               
            ],
            overlay: false,
            src: '',
            dialogReport: false,
            dialogSubmit: false,
            formClasses: ['4-1', '4-2', '4-3', '4-4', '4-5', '4-6', '4-7'],
            choices: [
                {id: 1, name: '1st Choice', formClass: null, subjectLines: []},
                {id: 2, name: '2nd Choice', formClass: null, subjectLines :[]},
                {id: 3, name: '3rd Choice', formClass: null, subjectLines: [],},
                {id: 4, name: '4th Choice', formClass:null, subjectLines: []},
            ],
            subjectLines: [],
            subjectsChosen:[],
            accept: false,
    }),

    methods: { 
        ...mapActions({
            getCsecSubjectSelectionLines: 'csec/getCsecSubjectSelectionLines',
            postSubjectSelectionLine: 'csec/postSubjectSelectionLine',
            postApplication: 'csec/postApplication',
            getApplication: 'csec/getApplication',
            getSubjectChoice: 'csec/getSubjectChoice',
        }),

        ...mapMutations({
            setLineSubjectChosen: 'csec/setLineSubjectChosen',
            setApplication: 'csec/setApplication',
        }),

        async initialize () {
            this.overlay = true;
            
            this.recordApplication.student_id = this.user.student_id;
            this.setApplication(this.recordApplication);

            for(let i = 1; i <= 4; i++){
                this.subjectsChosen[i] = [Array(7).fill(null)];
            }

            try {
                const[
                    { data: dataCsecSubjectSelectionLines },
                    { data: dataApplication },
                    { data: dataSubjectChoice}
                ] = await Promise.all([
                    this.getCsecSubjectSelectionLines(),
                    this.getApplication(),
                    this.getSubjectChoice(),
                ])
                this.subjectLines = dataCsecSubjectSelectionLines;
                this.mapSubjectChoicesLines(dataCsecSubjectSelectionLines);
                this.recordApplication = dataApplication;
                this.recordApplication.first_name = this.firstName;
                this.recordApplication.last_name = this.lastName;
                this.mapSelectedSubjectChoices(dataSubjectChoice);
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
            }
            this.overlay = false;
        },

        mapSelectedSubjectChoices(data){
            console.log('data: ', data);
            data.forEach(item => {
                let choice = this.choices.find(choice => choice.id === item.choice)
                if(!choice) return;
                choice.formClass = item.form_class_id
               
                // choice.formClass = item.form_class_id
                this.updateClassSubjectChoice(choice.id);
                switch(item.choice){
                    case 1: this.subjectsChosen[1][item.line] = item.subject_id; break;
                    case 2: this.subjectsChosen[2][item.line] = item.subject_id; break;
                    case 3: this.subjectsChosen[3][item.line] = item.subject_id; break;
                    case 4: this.subjectsChosen[4][item.line] = item.subject_id; break;
                }
                
            })
            console.log('subjectsChosen: ', this.subjectsChosen);
            console.log('choices: ', this.choices);
        },

        mapSubjectChoicesLines(data){
            const lines = [...new Set(data.map(item => item.line))];
            console.log('lines: ', lines);

            this.choices.forEach(choice => choice.subjectLines = lines.map(line => ({
                line: line,
                subjects: [],
                saveStatus: {
                    saving: false,
                    saveSuccess: false,
                    saveError: false,
                },
                disabled: true,
            })));

        },

        updateClassSubjectChoice(choice){
            let classChoice = this.choices.find(item => item.id === choice);
            let subjectLines = this.subjectLines.filter(item => item.form_class_id === classChoice.formClass);
            classChoice.subjectLines.forEach(item => {
                item.subjects = subjectLines.filter(line => line.line === item.line)
                item.disabled = false;
                if(item.subjects.length === 0) item.disabled = true;
                if(item.subjects.length === 1){
                    item.disabled = true;
                    this.subjectsChosen[choice][item.line] = item.subjects[0].subject_id
                    this.updateLineSubjectChoice(choice, item.line);
                }

            });
        },

        async updateLineSubjectChoice(choice, line){
            console.log('updating subject choice...')
            this.setLineSubjectChosen({
                choice, 
                line, 
                subject_id: this.subjectsChosen[choice][line],
                form_class_id: this.choices.find(item => item.id === choice).formClass,
                student_id: this.user.student_id
            });
            try {
                const response = await this.postSubjectSelectionLine();
                console.log('response: ', response)
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
            }
        },

        numberOnly($event){            
            if(!/\d/.test($event.key)) return $event.preventDefault();
        },

        submitApplicationForm(){

        },

        downloadApplicationForm(){
            this.src = `${process.env.VUE_APP_API_URI}/api/csec-subject-selection-form?student_id=${this.user.student_id}` 
            this.dialogReport = true;
        },

        closeReport(){
            this.dialogReport = false;
            this.src = '';
        },

        async updateApplication(){
            this.recordApplication.accept = this.accept;
            this.setApplication(this.recordApplication);
            try {
                const response = await this.postApplication();
                console.log('response: ', response)
            } catch (error) {
                error.response
            }
        }
             
    }

   
    
}
</script>